<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/orgin-countries"
      title="Lista krajów pochodzenia"
      :numeral_text="[
        'kraj pochodzenia',
        'kraje pochodzenia',
        'krajów pochodzenia',
      ]"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
